import { render, staticRenderFns } from "./SyncBadge.vue?vue&type=template&id=484b8e6c&scoped=true"
import script from "./SyncBadge.vue?vue&type=script&lang=js"
export * from "./SyncBadge.vue?vue&type=script&lang=js"
import style0 from "./SyncBadge.vue?vue&type=style&index=0&id=484b8e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484b8e6c",
  null
  
)

export default component.exports